'use client';

import CustomDivider from '@/components/custom-divider';
import { ScrollArea } from '@/components/ui/scroll-area';
import useMediaQuery from '@/hooks/use-media-query';
import { cn } from '@/lib/utils';
import { CustomMenuOverlay } from '../../components/custom-menu';
import { mediaBreakpoints } from '../common';
import { useCustomerSidebarStore } from '../store';
import FieldTreeFilter from './components/field-tree-filter';
import LeftSidebar from './components/left-sidebar';

export default function Sidebar({
    className,
    isSurveyEnabled = false,
}: {
    className?: string;
    isSurveyEnabled?: boolean;
}) {
    const { isShowSidebar, isShowMenuOverlay, setIsShowMenuOverlay } =
        useCustomerSidebarStore();

    const isDesktop = useMediaQuery(`(min-width: ${mediaBreakpoints}px)`);

    if (typeof isDesktop === 'boolean' && !isDesktop) {
        return (
            <CustomMenuOverlay
                open={isShowMenuOverlay}
                setOpen={setIsShowMenuOverlay}
                className='px-2'
            >
                <LeftSidebar isSurveyEnabled={isSurveyEnabled} />
                <FieldTreeFilter />
            </CustomMenuOverlay>
        );
    }

    return (
        <nav
            className={cn(
                'relative z-10 hidden h-full w-64 flex-col bg-background p-2 pr-0 pt-1 shadow-r-md transition-all duration-100 lg:flex 2xl:w-80',
                {
                    'w-[72px] 2xl:w-[72px]': !isShowSidebar,
                },
                className
            )}
        >
            <ScrollArea className='mr-2 h-[calc(100dvh-theme(height.16))] max-w-full'>
                <LeftSidebar isSurveyEnabled={isSurveyEnabled} />
                <FieldTreeFilter />
            </ScrollArea>
        </nav>
    );
}
